/**
 * updateGuestSchema — SCRUM-255 (DS-018 §10).
 *
 * Zod schema for `PATCH /organizations/:slug/guests/:id`. Reuses the field
 * schemas from create-guest.schema (single source of truth — no field-rule
 * drift between create and update).
 *
 * Partial-update semantics mirror the `Guest.update` aggregate method:
 *   - a field ABSENT (key not sent) → keep current;
 *   - a nullable field PRESENT and `null` → clear;
 *   - a value → set.
 * `name` is additionally nullable here (send `name: null` to clear the whole
 * name; the core invariant still forbids clearing the LAST identifying field —
 * that rejection is the aggregate's, → 422).
 *
 * `.strict()` rejects unknown keys; the `.refine` rejects an EMPTY patch
 * (`{}`) with a 400 — "update nothing" is a malformed request (mirrors
 * update-owner-profile). A meaningful no-op is not a valid PATCH.
 */
import { z } from 'zod';
import { guestNameSchema, guestEmailSchema, guestPhoneSchema, guestAddressSchema, guestNotesSchema, guestTagsSchema, } from './create-guest.schema.js';
export const updateGuestSchema = z
    .object({
    name: guestNameSchema.nullable().optional(),
    primaryEmail: guestEmailSchema.nullable().optional(),
    primaryPhone: guestPhoneSchema.nullable().optional(),
    address: guestAddressSchema.nullable().optional(),
    notes: guestNotesSchema.optional(),
    tags: guestTagsSchema.optional(),
})
    .strict()
    .refine((o) => Object.keys(o).length > 0, {
    message: 'empty_update: at least one field must be provided',
});
//# sourceMappingURL=update-guest.schema.js.map